import { render } from "./providerView.vue?vue&type=template&id=0353dc60&scoped=true"
import script from "./providerView.vue?vue&type=script&lang=js"
export * from "./providerView.vue?vue&type=script&lang=js"

import "./providerView.vue?vue&type=style&index=0&id=0353dc60&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0353dc60"]])

export default __exports__